(function () {
  'use strict';

  /* @ngdoc object
   * @name notificationsLog
   * @description
   *
   */
  angular
    .module('notificationsLog', [
      'ui.router'
    ]);
}());
